export default __webpack_public_path__ + "static/media/2.a0812b1c.jpg";